<template>
	<div
		class="rbc-main-card"
		v-if="collegeLeaderBoardData && collegeLeaderBoardData.length"
	>
		<div class="d-flex align-items-center justify-content-between">
			<div class="fw-M fs-14 fam-mont color-f5f5f5 d-flex align-items-center">
				<img
					src="../../assets/leaderboard/whitetrophy.svg"
					class="mr-2"
					alt=""
				/>
				Ranking by College
			</div>
			<div
				class="fw-M fs-14 fam-mont text-white d-flex align-items-center pointer"
				@click="checkAndRedirect()"
			>
				View all
				<img
					class="ml-1"
					src="../../assets/leaderboard/white-frdarw.svg"
					alt=""
				/>
			</div>
		</div>
		<div class="white-dashed-line my-3"></div>
		<section>
			<template v-if="loading">
				<div v-for="i in 3" :key="'shimmer' + i">
					<div class="d-flex justify-content-between gap-2">
						<b-skeleton type="avatar" width="20%"></b-skeleton>
						<b-skeleton width="55%"></b-skeleton>
						<b-skeleton width="10%"></b-skeleton>
					</div>
					<hr style="border-top: 1px solid rgb(82 87 95)" v-if="i <= 2" />
				</div>
			</template>
			<div
				v-for="(college, index) in collegeLeaderBoardData"
				:key="college.collegeId"
			>
				<div class="d-flex justify-content-between">
					<div
						class="fw-B fs-16 fam-lato text-white d-flex align-items-center"
						style="width: 80%"
					>
						<div style="width: 20%">
							<img :src="bindSvg(index)" class="ml-2" alt="" />
						</div>
						<div style="width: 80%" class="mb-3">
							{{ capitalizeWords(college.collegeName) }}
						</div>
					</div>
					<div class="fam-lato fw-B text-white fs-16">
						{{ college.score }}
						<span class="fw-R fs-14 color-E0E0E0EE"> Pts</span>
					</div>
				</div>
				<hr
					style="border-top: 1px solid rgb(82 87 95)"
					v-if="index < collegeLeaderBoardData.length - 1"
				/>
			</div>
		</section>
	</div>
</template>

<script>
import {
	getCollegeLeaderBoard,
	getAssessmentLeaderBoard,
} from "@/utils/apiFunctions";
import { hasAccess } from "@/utils/tokenCheck";
import EventBus from "@/utils/EventBus";
import { capitalizeWords } from "@/controllers/dashboard/helpers";
export default {
	name: "RankByCollegeCard",
	data() {
		return {
			collegeLeaderBoardData: [],
			loading: true,
		};
	},
	props: {
		type: String,
		gameType: String,
	},
	created() {
		this.getCollegeLeaderBoard();
	},
	methods: {
		capitalizeWords(str) {
			return capitalizeWords(str);
		},
		async getCollegeLeaderBoard() {
			try {
				let payload = {
					page: 0,
					count: 3,
				};
				let res;
				if (this.type === "assessment") {
					res = await getAssessmentLeaderBoard(this.gameType, {
						...payload,
						type: "college",
					});
					console.log("college", res.data);

					if (res.status == 200) {
						this.collegeLeaderBoardData = res.data.data.entries;
					}
				} else {
					res = await getCollegeLeaderBoard(this.gameType, payload);

					if (res.status == 200) {
						this.collegeLeaderBoardData = res.data.leaderboard;
					}
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		bindSvg(index) {
			if (index == 0) {
				return require("../../assets/newdesign/dashboard/games/first.svg");
			} else if (index == 1) {
				return require("../../assets/newdesign/dashboard/games/second.svg");
			} else if (index == 2) {
				return require("../../assets/newdesign/dashboard/games/third.svg");
			}
		},
		checkAndRedirect() {
			if (!hasAccess()) {
				EventBus.$emit("open-login-modal");
			} else {
				this.goToLeaderBoard();
			}
		},
		goToLeaderBoard() {
			let query;
			if (this.$route.name == "AssessmentMarketplace") {
				query = { type: "assessment", gameType: "technical", mode: "college" };
			} else if (this.gameType) {
				query = { type: this.type, gameType: this.gameType, mode: "college" };
			}
			this.$router.push({
				name: "Leaderboard",
				query: query,
			});
		},
	},
};
</script>

<style>
.rbc-main-card {
	height: fit-content;
	box-shadow: 0px 14.84px 32.1533px rgba(74, 58, 255, 0.07);
	border-radius: 8px;
	background-repeat: no-repeat;
	background-size: cover;
	background-image: url("../../assets/leaderboard/rbcbg.png");
	padding: 15px;
}
.color-f5f5f5 {
	color: #f5f5f5;
}

.color-E0E0E0EE {
	color: #e0e0e0ee;
}
</style>
